import * as React from 'react'
import cn from 'classnames'
import {
  WbRadioControl,
  WbControlError,
  WbControlHint,
} from '@workbench/react/dist'
import classes from './Radio.module.scss'

export interface RadioProps {
  id?: string
  label: string
  hint?: string
  error?: string
  disabled?: boolean
  inline?: boolean
}

export const Radio: React.FunctionComponent<
  RadioProps & JSX.IntrinsicElements['input']
> = ({
  id,
  label,
  hint,
  error,
  disabled,
  inline,
  className,
  ...inputProps
}) => {
  return (
    <WbRadioControl
      className={cn(classes.radio, { [classes.inline]: inline }, className)}
    >
      <label>
        <input type="radio" id={id} {...inputProps} disabled={disabled} />
        {label}
      </label>

      {hint && <WbControlHint>{hint}</WbControlHint>}
      {error && <WbControlError>{error}</WbControlError>}
    </WbRadioControl>
  )
}
